import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { installGlobalErrorReporting, reportError, reportQueryError } from './lib/errorReport';
import { ErrorBoundary } from './ui/ErrorBoundary';
import { ToastProvider } from './ui/Toast';
import './styles/legacy.css';
import './styles/extra.css';

installGlobalErrorReporting();

const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: (err, q) => reportQueryError(err, q.queryKey) }),
  mutationCache: new MutationCache({ onError: err => reportError('query', err, 'ghi dữ liệu') }),
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: true, retry: 1 } },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ToastProvider>
            <App />
          </ToastProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
